<nav class="tab-bar">
  <button 
    *ngFor="let tab of tabs" 
    class="tab-button"
    [class.active]="isActive(tab.route)"
    (click)="navigateTo(tab.route)"
    type="button">
    <img [src]="tab.icon" [alt]="tab.name" class="tab-icon" />
    <span class="tab-label">{{ tab.name }}</span>
  </button>
</nav>
